import { IMAGE_URL_VALIDATOR, VALID_CSS_UNITS_VALIDATOR } from './regex';

export const validImageUrl = (url: string) => IMAGE_URL_VALIDATOR.test(url);
export const validCSSUnit = (rule: string) => VALID_CSS_UNITS_VALIDATOR.test(rule);

export const getValidCSSUnit = (rule:string, fallback: any = null) => (validCSSUnit(rule) ? rule : fallback);
